import { FETCH_PAY_TIMESHEETS, CLEAR_PAY_TIMESHEETS } from "../actions/types";

const initialState = {
  items: []
};

export default function(state = initialState, action) {
  switch (action.type) {
    case FETCH_PAY_TIMESHEETS:
      return {
        ...state,
        items: action.payload
      };
    case CLEAR_PAY_TIMESHEETS:
      return {
        ...state,
        items: []
      };
    default:
      return state;
  }
}
